import React, { useState } from 'react';

interface ChatInterfaceProps {
    messages: { ID: string; Sender: string; Text: string; Timestamp: string }[];
    onSendMessage: (text: string) => void;
}

const ChatInterface: React.FC<ChatInterfaceProps> = ({ messages, onSendMessage }) => {
    const [newMessage, setNewMessage] = useState('');

    const handleSendMessage = () => {
        if (newMessage.trim()) {
            onSendMessage(newMessage);
            setNewMessage('');
        }
    };

    return (
        <div className="w-3/4 h-full flex flex-col" style={{ maxHeight: '100vh' }}>
            <div className="flex-1 p-4 overflow-y-auto">
                {messages.map((message) => (
                    <div key={message.ID} className="mb-4">
                        <div className="font-bold">{message.Sender}</div>
                        <div className="text-sm">{message.Text}</div>
                        <div className="text-xs text-gray-400">{message.Timestamp}</div>
                    </div>
                ))}
            </div>
            <div className="p-4 bg-gray-100 flex" style={{ position: 'sticky', bottom: 0 }}>
                <input
                    type="text"
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    placeholder="Type a message..."
                    className="flex-1 p-2 border border-gray-300 rounded mr-2"
                />
                <button onClick={handleSendMessage} className="bg-blue-500 text-white p-2 rounded">
                    Send
                </button>
            </div>
        </div>
    );
};

export default ChatInterface;